import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Overlays',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
